import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Import icons you want to use
import regularIcons from '@/icons/regular-icons';
import solidIcons from '@/icons/solid-icons';

// Add icons to the library
library.add(...solidIcons, ...regularIcons);

export default (app) => {
  app.component('FontAwesomeIcon', FontAwesomeIcon);
};
